import script from "./EmployersInfo.vue?vue&type=script&setup=true&lang=js"
export * from "./EmployersInfo.vue?vue&type=script&setup=true&lang=js"

import "./EmployersInfo.vue?vue&type=style&index=0&id=682645ac&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-682645ac"]])

export default __exports__